export const SOLID = 'solid';
export const LINEAR = 'linear';
export const RADIAL = 'radial';
